import React, { useCallback } from 'react';
import styled from 'styled-components';
import { fontSize, fontWeight } from '../style/tokens';

const Select = styled.select`
  padding-left: 10px;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #f1f4f9;
  width: 100%;
  height: 36px;
  color: #3e3c3c;
`;

const Option = styled.option`
  font-style: normal;
  font-weight: ${fontWeight.normal};
  font-size: ${fontSize.base};
  line-height: 17px;
  color: #3e3c3c;
`;

interface SettingsDropDownProps {
  options: Array<{ value: string; name: string }>;
  onSelect: (value: string) => void;
  selectedValue?: string;
}

const SettingsDropDown = ({ options, onSelect, selectedValue }: SettingsDropDownProps) => {
  const handleChange = useCallback((event) => onSelect(event.target.value), []);
  // useEffect(() => {
  //   // options?.length && onSelect(options[0].value);
  // }, [options]);
  return (
    <Select onChange={handleChange} value={selectedValue}>
      {options?.map(({ value, name }) => (
        <Option key={value} value={value}>
          {name}
        </Option>
      ))}
    </Select>
  );
};
export default SettingsDropDown;
